export const preventEnteringSpecialChar = (event): KeyboardEvent =>
  ['e', 'E', '+', '-'].includes(event.key) && event.preventDefault();

export const preventEnteringParticularChar = (event: KeyboardEvent, char: string) =>
  char.charAt(0).includes(event.key) && event.preventDefault();
